import React from "react";

import "./raisedTextBox.less";

const RaisedTextBox = (props) =>(<div className="raised-text-box">{props.children}</div>);

export default RaisedTextBox;


// WEBPACK FOOTER //
// ./src/react/views/generic/RaisedTextBox.jsx